<template>
    <HoverPopUp>
        <template v-slot:element>
            <a
                :href="Booking.showUrl(booking.uuid)"
                target="_blank"
                class="btn-link me-1"
            >
                <SvgIcon :path="mdiOpenInNew" :size="15" type="mdi" />
            </a>
        </template>
        <template v-slot:popup-content>
            <div>
                <div class="d-flex flex-row align-items-center">
                    <SvgIcon
                        type="mdi"
                        :path="mdiOpenInNew"
                        class="text-primary me-1"
                        :size="20"
                    ></SvgIcon>
                    <strong class="text-primary">{{ booking.uuid }}</strong>
                </div>

                <br />

                <div v-if="booking.region">
                    <strong>Region</strong>
                    <br />
                    {{ booking.region?.name }}
                    <br />
                </div>

                <strong>Estimated Distance</strong>
                <br />
                {{ ((booking.estimated_distance ?? 0) / 1000).toFixed(2) }} Km
                <br />

                <div v-if="props.showServiceType && booking.service_type?.name">
                    <strong>Service Type</strong>
                    <br />
                    {{ booking.service_type?.name }}
                    <br />
                </div>
            </div>
        </template>
    </HoverPopUp>
</template>
<script setup lang="ts">
import { computed } from "vue";
import HoverPopUp from "@components/HoverPopUp/HoverPopUp.vue";
import BookingResource from "@customTypes/resources/BookingResource";
import { DateTime } from "luxon";
import { mdiClockTimeEightOutline, mdiOpenInNew } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import Booking from "@classes/Booking";

const props = withDefaults(
    defineProps<{
        booking: BookingResource;
        showServiceType?: boolean;
    }>(),
    {
        showServiceType: false,
    }
);
</script>
